import { Discharge, FolderItem, Patient } from "@/src/data/allTypes";
import {
  getAge,
  getItemId,
  getName,
  getUserId,
  isMobile,
  jsonAbstract,
} from "@/src/utils/utils";
import { openPatientDashboard } from "../app/patients/patientDashboard";
import { Button, IconButton } from "./buttons";
import DischargeButton, {
  openDischargeDrawer,
} from "../app/hospitalisation/historique/dischargeButton";
import { getStandardConfidentiality } from "../app/patients/confidentialitiesHook";
import { closeDrawer, openDrawer } from "./dialogs";
import TransferButton from "../app/hospitalisation/historique/transferButton";
import TemporaryLeaveButton from "../app/hospitalisation/historique/temporaryLeaveButton";
import { FiEdit2 } from "react-icons/fi";
import { openPatientIdentityDrawer } from "../app/patients/patientIdentityForm";
import { useState } from "react";

export function FolderItemTitle({
  currentPatient,
  parent,
  showDischargeButton = false,
}: {
  currentPatient: Patient | null | undefined;
  parent: FolderItem;
  showDischargeButton: boolean;
}) {
  const [patient, setPatient] = useState<Patient | null | undefined>(
    currentPatient
  );
  if (!patient) return null;

  function shouldShowDischargeButton() {
    return (
      showDischargeButton && parent?.type == "hospitalisation" && parent?.bed
    );
  }

  return (
    <div className="c1-auto acenter ">
      <div className="capitalize">
        <strong>{getName(patient)}</strong>
        <span className="normal gray "> {getAge(patient)}</span>
        <FiEdit2
          className="pointer mleft10 "
          onClick={async () => {
            if (!patient) return;
            await openPatientIdentityDrawer({
              patient: patient,
              onChange: (newValue) => {
                setPatient(newValue);
              },
            });
          }}
        ></FiEdit2>
        <div className="gray normal">Identifiant: {patient.shortId?.toUpperCase()}</div>
      </div>
      <div className={` ${shouldShowDischargeButton() ? "c2" : "c1"} gap10`}>
        {shouldShowDischargeButton() && (
          <Button
            type={"tertiary"}
            color="orange"
            onClick={async () => {
              if (parent?.type != "hospitalisation")
                throw new Error("Parent is not a hospitalisation");
              await openDrawer({
                id: "sortieTypeDrawer",
                title: "Choisir une action",
                content: (
                  <div className="c1 gap10">
                    <TransferButton
                      patient={patient!}
                      parent={parent}
                      onSave={() => {
                        closeDrawer("sortieTypeDrawer");
                      }}
                    />

                    <TemporaryLeaveButton
                      patient={patient!}
                      parent={parent}
                      onSave={() => {
                        closeDrawer("sortieTypeDrawer");
                      }}
                    />
                    <DischargeButton
                      patient={patient!}
                      parent={parent}
                      onSave={() => {
                        closeDrawer("sortieTypeDrawer");
                      }}
                    />
                  </div>
                ),
              });
            }}
          >
            <span className="f13">Sortie</span>
          </Button>
        )}
        <Button
          type={"tertiary"}
          onClick={async () => {
            await openPatientDashboard(patient);
          }}
        >
          <span className="f13">
            {isMobile() ? "Dossier" : "Dossier complet"}
          </span>
        </Button>
      </div>
    </div>
  );
}
